import { webshopSettings } from '~/store/webshopSettings'

export default defineNuxtRouteMiddleware((to, from) => {
    if (webshopSettings().defaultLanguage && webshopSettings().defaultLanguage !== 'nl' && from.fullPath === '/' && to.fullPath === '/') {
        return navigateTo(webshopSettings().defaultLanguage, { redirectCode: 301 })
    }
})
